function calculateProductHeight({ from = 'unknown' } = {}) {
    if ($('.productList').length === 0) {
        console.warn('⚠️ Nenhuma lista de produtos encontrada para ajustar a altura das informações.');
        return;
    }

    $('.productList').each(function () {
        const product_list = this;
        const $productList = $(product_list);
        const tab_panel = product_list.closest('.product-list-tabs .tab__panel');
        const carousel = product_list.querySelector('.productList__products.swiper, .products.swiper');

        if (
            !product_list.getClientRects().length ||
            (tab_panel && !tab_panel.classList.contains('js-active')) ||
            (carousel && !carousel.swiper)
        ) {
            return;
        }

        if (from === 'footer' && $productList.data('aos-after-animate') == 'calculateProductHeight') {
            return;
        }

        $productList
            .data('info-height', '')
            .attr('data-info-height', '');

        product_list.style.removeProperty('--productGrid-info-height');

        let maxInfoHeight = 0;

        product_list.querySelectorAll('.product-list-informations').forEach((information) => {
            const information_rect = information.getBoundingClientRect();

            if (information_rect.width <= 0 || information_rect.height <= 0) {
                return;
            }

            maxInfoHeight = Math.max(maxInfoHeight, information_rect.height);
        });

        if (maxInfoHeight <= 0) {
            return;
        }

        const normalized_height = Math.ceil(maxInfoHeight);

        $productList
            .data('info-height', normalized_height)
            .attr('data-info-height', normalized_height);

        product_list.style.setProperty('--productGrid-info-height', `${normalized_height}px`);
    });
}

export default function init({ from = 'unknown' } = {}) {
    calculateProductHeight({ from });
    window.calculateProductHeight = calculateProductHeight;
}

export { init as productHeightAdjust };
